import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const DeleteSubscriptionModel = types
  .model("DeleteSubscriptionModel", {
    res: types.string,
  })
  .actions((self) => ({
    fetch(ID) {
      Framework.sendEvent("DELETING_SUBSCRIPTION_DATA", {ID});
    },
    set(response) {
      let status = response.data.response;
      let data;
      if (status === 204) {
        data = `The subscription has been deleted successfully.`;
      } else {
        data = status;
      }
      applySnapshot(self, {
        res: data,
      });
    },
    reset() {
      applySnapshot(self, {
        res:"Oops...Something went wrong. Please try again.",
      });
    },
  }));

export default DeleteSubscriptionModel;
